import axios, { AxiosInstance } from 'axios';
import qs from 'query-string';
import { handleAccess, handleError } from 'services/controllers/interceptors';

import { getVariable } from 'helpers/environment.utils';

export const paymentsAxios = init();

function init(): AxiosInstance {
  const client = axios.create({
    baseURL: getVariable('REACT_APP_ENV_API_PAYMENT_BASE'),
    paramsSerializer: (params) => qs.stringify(params),
  });

  client.interceptors.request.use(handleAccess);
  client.interceptors.response.use(undefined, handleError());

  return client;
}
